module.exports = __webpack_public_path__ + "static/media/pic_2_17.761f02a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_2_17.jpg
// module id = 1835
// module chunks = 0 1